

import { useContext, useEffect, useState } from 'react'


import 'bootstrap-daterangepicker/daterangepicker.css';

import { useLocation, useNavigate } from 'react-router-dom';
import { LoyaltyContext } from '../../../context/loyalty/LoyaltyContext';
import { useForm } from '../../../components/hooks/useForm';
import Message from '../../../components/ui/Message';
import { WalletConfigLink } from '../settings/wallet/WalletConfigLink';
import { useRequiredFields } from '../../../hooks/useRequiredFields';




export const LoyaltyClientPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [isFormValid, setIsFormValid] = useState(false);
    const { addClient } = useContext(LoyaltyContext);
    const [errorMessage, setErrorMessage] = useState('');
    const required = useRequiredFields();
    const [successMessage, setSuccessMessage] = useState('');
    const [services, setServices] = useState([]);

    var supplier;

    if (state) {
        supplier = state.supplier;
    } else {
        supplier = {
            nombre: '',
            correo: '',
            plataforma: 'android'
        }
    }


    const { formState, onInputChange } = useForm(supplier);

    const { nombre, correo, plataforma } = formState



    const handleSave = async () => {

        const formValid = nombre.length > 0 && correo.length > 0
        if (!formValid) {
            required.fail();
            setErrorMessage("Debe completar los campos requeridos.");
            return false;
        }

        var resp = await addClient(formState);
        if (resp == "success") {
            setSuccessMessage("Cliente creado correctamente.");
        } else {
            setErrorMessage(resp);
        }
    }

    const removeError = () => {
        setErrorMessage('');
    }

    const removeSucessMessage = () => {
        setSuccessMessage('');
        navigate(-1);
    }

    return (

        <div className='container d-flex align-items-center justify-content-center mt-5' style={styles.container}>


            <div className='col-md-6'>
                <h3>{'Crear cliente'}</h3>
                <hr />

                <form className="row g-3 " >

                    <div className="mb-3">
                        <label htmlFor="supplierNameInput" className="form-label">Nombre *</label>
                        <input
                            id='supplierNameInput'
                            type="text"
                            className={`form-control${required.mark(!nombre)}`}
                            placeholder="Nombre"
                            name="nombre"
                            value={nombre}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>



                    <div className="mb-3">
                        <label htmlFor="correoInput" className="form-label">Correo *</label>
                        <input
                            id='correoInput'
                            type="text"
                            className={`form-control${required.mark(!correo)}`}
                            placeholder="Correo"
                            name="correo"
                            value={correo}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="platformSelect" className="form-label">Dispositivo</label>
                        <select id='platformSelect' className="form-select" name='plataforma' onChange={onInputChange} defaultValue={"android"} >
                            <option value="android">Android</option>
                            <option value="ios">IOS</option>
                        </select>
                    </div>




                    <div className='container d-flex align-items-center justify-content-center mt-5'>
                        <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                        <button type="button" onClick={handleSave} className="btn btn-primary ms-5" >Guardar</button>
                    </div>
                </form>
                <div style={{ height: '100px' }}></div>
            </div>
            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)'>
                    <WalletConfigLink message={errorMessage} />
                </Message> : ''
            }
            {
                successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }



        </div>
    )
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
